import request from './request'

export function listStocktaking(data) {
  return request.post('/inventory/stocktakings/list', data)
}
export function getStocktaking(id) {
  return request.get('/inventory/stocktakings/' + id)
}
export function saveStocktaking(data) {
  return request.post('/inventory/stocktakings', data)
}
export function updateStocktaking(data) {
  return request.post('/inventory/stocktakings/update', data)
}
export function deleteStocktaking(ids) {
  return request.post('/inventory/stocktakings/delete', ids)
}
export function generateStocktaking(stocktakingId) {
  return request.post('/inventory/stocktakings/generate', { stocktakingId })
}
export function saveStocktakingCounts(stocktakingId, lineList) {
  return request.post('/inventory/stocktakings/save-counts', { stocktakingId, lineList })
}
export function postStocktaking(stocktakingId) {
  return request.post('/inventory/stocktakings/post', { stocktakingId })
}
